module.exports = __webpack_public_path__ + "static/4-d5fdba165ef4077387bf396c33fc6b74.jpg";